<template>
  <div class="absence-reasons__absence">
    <div>
      <div class="absence-reasons__absence__title">
        <p class="absence-reasons__absence__title-text">
          <b>{{ reason.title }}</b>
          <span class="do-sd-badge" v-if="hasSdAbsenceCode">SD</span>
          <span class="do-opus-badge" v-if="hasOpusAbsenceCode">OPUS</span>
        </p>
        <p>
          <span v-if="isOngoing" class="badge badge--orange badge--small badge--clickable"
                @click="setTheEditAbsenceReason">{{ $t('vue2.subs_ongoing_absence.ongoing_absence') }}</span>
          <span v-if="!isOngoing && getIsAbsenceMultipleDays"
                class="badge badge--small"> {{ $t('vue2.substitution_user.multiple_days') }}</span>
        </p>
      </div>
      <p>
        <template v-if="getSerialListItem">
          {{ formatDate(getSerialListItem.from_date) }}
          - {{ formatDate(getSerialListItem.to_date) }}, {{ showTime(reason.start) }} - {{ showTime(reason.end) }}
        </template>
        <template v-else>
          {{ showDate(reason.start) }} -
          <span>{{ showTime(reason.end) }}</span>
        </template>
      </p>
    </div>
    <div class="absence-reasons__absence__right">
      <div class="absence-reasons__absence__right__edits">
              <span class="icon-bin icon__bg-circle icon__bg-circle--danger deleteAbsence"
                    @click="setReadyToDelete(reason)"
                    :content="$t('vue2.common.delete')"
                    v-tippy="{
                    arrow: true,
                    placement : 'left'
                  }">
      </span>
        <span class="icon-wrench icon__bg-circle"
              v-if="getSerialListItem"
              @click="setTheEditAbsenceReason(reason)"
              :content="$t('vue2.common.edit')"
              v-tippy="{
                    arrow: true,
                    placement : 'left'
                  }">
    </span>
      </div>
      <span class="icon-clock icon__bg-circle"
            @click="showLog(reason)"
            :content="$t('vue2.common.log')"
            v-tippy="{
                    arrow: true,
                    placement : 'left'
                  }">
      </span>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    user_calendar_id: {},
    reason: {
      type: Object
    },
    internalNote: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      start: this.reason.start,
      end: this.reason.end
    }
  },
  computed: {
    longAbsentList () {
      return this.$store.state.subs.longAbsentList
    },
    longAbsentListInHash () {
      return this.$store.getters.longAbsentListInHash
    },
    getSerialListItem () {
      return this.reason && this.reason.event_serial_id ? this.longAbsentListInHash[this.reason.event_serial_id] : false
    },
    isOngoing () {
      return this.getSerialListItem ? this.getSerialListItem.ongoing : false
    },
    getIsAbsenceMultipleDays () {
      let serialItem = this.getSerialListItem
      return serialItem && moment(serialItem.from_date).format('YYYY-MM-DD') !== moment(serialItem.to_date).format('YYYY-MM-DD')
    },
    absenceReasonSubject () {
      const reasons = this.$store.state.subs.absenceReasons || []
      const subjectId = this.reason && this.reason.subject_id
      if (!subjectId) return null
      return reasons.find(r => r.id === subjectId) || null
    },
    hasSdAbsenceCode () {
      const serial = this.getSerialListItem
      if (serial && serial.sd_absence_code_id) return true
      return !!(this.absenceReasonSubject && this.absenceReasonSubject.sd_absence_code_id)
    },
    hasOpusAbsenceCode () {
      const serial = this.getSerialListItem
      if (serial && serial.kmd_absence_code_id) return true
      return !!(this.absenceReasonSubject && this.absenceReasonSubject.kmd_absence_code_id)
    }
  },
  methods: {
    showDate (date) {
      return moment(date).format('DD. MMM, LT')
    },
    showTime (date) {
      return moment(date).format('LT')
    },
    formatDate (date) {
      return moment(date).format('ll')
    },
    showLog (event) {
      this.$emit('showLog', event)
    },
    setReadyToDelete () {
      this.$store.commit('setIsActiveAbsenceReasonIsReadyToDelete', true)
      this.$store.commit('setActiveAbsenceReason', this.reason)
    },
    isEndDateSameDayAsStart (startDate, endDate) {
      const start = moment(startDate).format('YYYY-MM-DD')
      const end = moment(endDate).format('YYYY-MM-DD')
      return moment(start).isSame(end)
    },
    setTheEditAbsenceReason () {
      let absence = this.getSerialListItem ? this.getSerialListItem : this.reason
      absence.internal_note = this.internalNote
      this.$store.commit('setActiveAbsenceReason', absence)
    },
    getIsAbsenceOngoing (reason) {
      return this.getSerialListItem && this.getSerialListItem.ongoing
    }
  },
  mounted () {
    this.$emit('start', this.start)
    this.$emit('end', this.end)
    this.$store.dispatch('subsGetLongAbsenceList')
  }
}
</script>

<style scoped>
@import '../../assets/css/variables.css';

.absence-reasons__absence {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #333;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  padding: 2px 6px;
  margin-bottom: 5px;
}

.absence-reasons__absence > div:first-child {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.deleteAbsence > span {
  cursor: pointer;
  background-color: white;
  border-radius: 50%;
  color: #8e8e93;
  font-size: 14px;
  padding: 5px;
}

.deleteAbsence > span:hover {
  transition: all 0.25s;
  background-color: var(--danger);
  color: white;
}

h4.go_to_calendar {
  text-align: left;
}

.absence-reasons__absence__title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
  gap: 0.5rem;
}

.absence-reasons__absence__title-text {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
}

.do-opus-badge,
.do-sd-badge {
  display: inline-flex;
  font-weight: 400;
  border: 1px solid #facc17;
  border-radius: 4px;
  background-color: #fefce8;
  padding: 3px 4px;
  font-size: 9px;
  line-height: 1.5;
  color: #a26206;
}

.absence-reasons__absence__right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.absence-reasons__absence__right__edits {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// SubsUserAbsenceReason.vue?34b7807c